import { completeSignIn } from "modules/auth";
import { EPSignUpRequest, signUp, signUpEp, SignUpRequest, TokensResponse } from "services";
import { AppDispatch, AppThunk } from "store";
import { registrationError, registrationRequest, registrationSuccess } from "./reducer";
import { AxiosResponse } from "axios";
import { IErrorContext } from "modules/common";

export const registerUser =
    (data: SignUpRequest | EPSignUpRequest): AppThunk =>
    async dispatch => {
        try {
            dispatch(registrationRequest());

            let response: AxiosResponse<TokensResponse & IErrorContext>;
            if ("role" in data) response = await signUpEp(data);
            else response = await signUp(data);
            
            const [first] = response.data.statuses;
            dispatch(registrationSuccess({ successMessage: first.message }));
            completeSignIn(
                dispatch as AppDispatch,
                response.data.accessToken,
                response.data.refreshToken
            );
        } catch (error: any) {
            const [first] = error.response.data.statuses;
            dispatch(registrationError({ errorMessage: first.message }));
        }
    };
